import {AddressHistoryState} from "./AddressHistoryState";
import {Action, handleActions} from "redux-actions";
import {ADDRESS_HISTORY_FETCHED, ADDRESS_HISTORY_UPDATED} from "../../action/addressHistory/actionType";
import AddressHistory from "../../../model/addressHistory/AddressHistory";

const initState: AddressHistoryState = {
	history: {}
};


const reducer = handleActions({
	[ADDRESS_HISTORY_FETCHED]: (state: AddressHistoryState, action: Action<ADDRESS_HISTORY_FETCHED>): AddressHistoryState => {
		const history: { [key: string]: AddressHistory[] } = {};
		Object.keys(state.history).forEach(key => {
			if (key != action.payload.contactId)
				history[key] = state.history[key];
		});
		history[action.payload.contactId] = action.payload.history;
		return {...state, history}
	},
	[ADDRESS_HISTORY_UPDATED]: (state: AddressHistoryState, action: Action<ADDRESS_HISTORY_UPDATED>): AddressHistoryState => {
		const history: { [key: string]: AddressHistory[] } = {};
		Object.keys(state.history).forEach(key => {
			if (key != action.payload.contactId)
				history[key] = state.history[key];
		});
		history[action.payload.contactId] = action.payload.history;
		return {...state, history}
	}
}, initState);

export default reducer;